import React from 'react';

const Header = () => {
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <a className="navbar-item" href="/">
          <img src="/images/logo.png" alt="IDIX Consulting Logo" style={{ transform: 'scale(0.25)' }} />
        </a>
      </div>
      <div className="navbar-menu">
        <div className="navbar-end">
          <a className="navbar-item" href="#about">
            About
          </a>
          <a className="navbar-item" href="#services">
            Services
          </a>
          <a className="navbar-item" href="#skills">
            Our Skills
          </a>
          <a className="navbar-item" href="#contact">
            Contact
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Header;
